<template>
  <div class="respace">
    <b-form-group
      label-for="input-statement"
      label-cols-sm="4"
      label-cols-lg="2"
      label="공통 지시문"
    >
      <b-form-input
        id="input-statement"
        v-model="statement"
        :class="statement_valid_cls"
      ></b-form-input>
    </b-form-group>

    <div>지문/보기</div>
    <NormalEditor
      key="meta_id2"
      ref="editor5"
      :content="jimun"
      cls="readingWide"
      func="updateJimun"
    />

    <!-- 어휘주석 추가 -->

    <b-container fluid>
      <b-row :key="x.idx" v-for="x in jimunvoca" class="wordaddrow">
        <b-col cols="3">
          <b-input v-model="x.word" />
        </b-col>
        <b-col cols="5">
          <b-input v-model="x.comment" />
        </b-col>
        <b-col>
          <b-button @click="removeJimunVoca(x)" variant="danger">
            D(-)
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group>
            <b-button
              @click="addJimunVoca"
              block
              size="sm"
              variant="primary"
              title="어휘주석 추가+"
              >어휘주석 추가+</b-button
            >
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <!-- 끝 -->

    <div>원문</div>

    <NormalEditor
      key="meta_id"
      ref="editor88"
      :content="plainJimun"
      cls="readingWide"
      func="updatePlainJimun"
    />

    <!-- 소재 및 난이도 추가 -->
    <b-container>
      <b-row>
        <b-col offset="1" sm="5" lg="5">
          <b-form-select
            id="jimun-subject"
            v-model="jimun_subject"
            :options="jimun_subject_options"
          >
          </b-form-select>
        </b-col>
        <b-col sm="5" lg="5">
          <b-form-select
            id="jimun-level"
            v-model="jimun_level"
            :options="jimun_level_options"
          >
          </b-form-select>
        </b-col>
      </b-row>
    </b-container>

    <div>해석</div>
    <NormalEditor
      key="meta_id3"
      ref="editor6"
      :content="translate"
      func="updateTranslate"
    />

    <!-- <div>해설</div>
    <NormalEditor ref="editor7" :content="qcomment" func="updateQComment" /> -->
    <div
      style="text-align: left; margin-bottom: 10px"
      v-if="meta_id != '' && std_type != '2'"
    >
      <b-button
        @click="openDup()"
        size="sm"
        style="width: 100%"
        variant="danger"
        >중복지문 체크</b-button
      >
    </div>

    <div style="text-align: right">
      <b-button @click="metasave()" size="sm" variant="primary">{{
        metatext
      }}</b-button>
    </div>

    <hr />
    <QType1GroupList />
    <QType1GroupItemPicker />
    <QType1GroupItem />
    <ReadingDup :main_metaid="idf" />
  </div>
</template>

<script>
import NormalEditor from "@/components/NormalEditor";

import QType1Answer from "@/components/question/QType1Answer";
import ReadingDup from "@/components/question/ReadingDup";

import QType1GroupItem from "@/components/question/QType1GroupItem";
import QType1GroupItemPicker from "@/components/question/QType1GroupItemPicker";

import QType1GroupList from "@/components/question/QType1GroupList";

export default {
  data() {
    return {
      idf: null,
      componentKey: 0,
    };
  },
  components: {
    NormalEditor,
    QType1GroupItem,
    QType1GroupList,
    QType1GroupItemPicker,
    ReadingDup,
  },
  mounted() {
    // this.$store.commit("updateDebug", "그룹문항 마운트");
    //변경시 리셋코드
    if (this.$store.state.questionmeta.id == "") {
      this.$refs.editor5.reset();
      this.$refs.editor6.reset();
      // this.$refs.editor7.reset();
      this.$refs.editor88.reset();
    }
  },
  watch: {
    tabIndex(to, from) {
      this.$store.commit("updateDebug", "탭이 변경됨");
    },
    chapter(to, from) {
      if (to === "") {
        this.$refs.editor5.reset();
        this.$refs.editor6.reset();
        // this.$refs.editor7.reset();
        this.$refs.editor88.reset();
      }
    },
    plainJimunImsi(to, from) {
      console.log("jimun changed");
    },
  },
  computed: {
    meta_id() {
      return this.$store.state.questionmeta.id;
    },
    meta_id2() {
      return this.$store.state.questionmeta.id + "_";
    },
    meta_id3() {
      return this.$store.state.questionmeta.id + "_1";
    },

    jimun_subject_options() {
      return this.$store.state.jimun_subject_options;
    },

    jimun_subject: {
      set(val) {
        this.$store.commit("updatePlainJimunSubject", val);
      },
      get() {
        return this.$store.state.questionmeta.plain_jimun_subject;
      },
    },

    jimun_level_options() {
      return this.$store.state.jimun_level_options;
    },

    jimun_level: {
      set(val) {
        this.$store.commit("updatePlainJimunLevel", val);
      },
      get() {
        return this.$store.state.questionmeta.plain_jimun_level;
      },
    },

    std_type() {
      return this.$store.state.questionmeta.std_type;
    },
    chapter() {
      return this.$store.state.questionmeta.chapter;
    },

    statement_valid_cls() {
      return this.$store.state.valid.statement;
    },

    tabIndex() {
      return this.$store.state.tabIndex;
    },

    metatext() {
      return this.$store.state.questionmeta.id !== ""
        ? "메타 수정"
        : "메타 저장";
    },
    qtype1_answers() {
      return this.$store.state.qtype1_answers;
    },

    jimun() {
      // return this.$store.state.questionmeta.jimun;
      return this.$store.state.questionmeta.jimun_imsi;
    },

    jimunvoca() {
      return this.$store.state.questionmeta.jimunwords;
    },

    plainJimunImsi() {
      return this.$store.state.questionmeta.plain_jimun_imsi;
      // return this.$store.state.questionmeta.plain_jimun;
      // return "mysample";
    },

    plainJimun: {
      get() {
        return this.$store.state.questionmeta.plain_jimun_imsi;
      },
      set(val) {
        this.$store.commit("updatePlainJimunImsi", val);
      },
    },

    translate: {
      get() {
        return this.$store.state.questionmeta.translate_imsi;
      },
    },
    qcomment() {
      return this.$store.state.questionmeta.qcomment_imsi;
    },
    statement: {
      get() {
        return this.$store.state.questionmeta.statement;
      },
      set(val) {
        this.$store.commit("updateStatement", val);
      },
    },
    groupitems() {
      return this.$store.state.qforms;
    },
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    addJimunVoca() {
      this.$store.dispatch("addJimunVoca");
    },
    removeJimunVoca(voca) {
      this.$store.dispatch("removeJimunVoca", voca);
    },

    async metasave() {
      let _k = await this.$store.dispatch("saveorupdateQType1GroupMeta");

      if (!_k) {
        alert("폼을 확인해주세요");
        return false;
      }

      console.log(_k);

      let msg = `${this.metatext}을 하였습니다.`;
      alert(msg);
    },
    imsi() {},
    openDup() {
      // this.formChapter = {};
      this.$nextTick(() => {
        this.$bvModal.show("myiddup");
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.respace {
  padding-top: 10px;
}
.invalid {
  border: 2px solid red;
}

.button_wrapper {
  button {
    margin-right: 5px;
  }
}
.wordaddrow {
  margin-bottom: 4px;
}
</style>
